import NavBarNavLink from '../../../parts/navlinks/NavBarNavLink'
import house from '../../../../assets/images/svg/house'
import person from '../../../../assets/images/svg/person'
import friends from '../../../../assets/images/svg/friends'
import wand from '../../../../assets/images/svg/wand'

const NavBar = ({ css = "" }) => {

  const navCss = `relative w-full flex flex-col pb-4 text-darkRed gap-3 w-full lg:py-2 lg:px-2 ${css}`
  const navlinkCss = 'flex-col navcard'
  const navlinksData = [
    { to: "home", img: house, txt: "Accueil" },
    { to: "profile", img: person, txt: "Profil" },
    { to: "friends", img: friends, txt: "Amis" },
    { to: "wishes", img: wand, txt: "Souhaits" },
  ]
  const navlinksArray = navlinksData.map(data =>
    <NavBarNavLink
      key={data.txt}
      to={data.to}
      img={<div className="h-7 w-7">{data.img}</div>}
      txt={data.txt}
      css={navlinkCss}
    />
  )

  return (
    <nav className={navCss}>
      <div className="h-2 shadow-md shadow-ivory lg:hidden" />
      <div className='global-px pt-1 pb-4 flex flex-row gap-4 overflow-y-hidden overflow-x-auto sm:justify-center'>
        {navlinksArray}
        {/* Cette div est ajouté afin que le padding de droite s'applique bien sur téléphone. */}
        <span className='w-5 sm:hidden'>&nbsp;</span>
      </div>
    </nav>
  )
}

export default NavBar